export default "__VITE_ASSET__Bs9w2Qnj__"